import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=b364e9a4&"
import script from "./mail.vue?vue&type=script&lang=js&"
export * from "./mail.vue?vue&type=script&lang=js&"
import style0 from "./mail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports